import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toTop",
  "use": "icon-toTop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-toTop\"><defs><style type=\"text/css\"></style></defs><path d=\"M859.67 860.723L511.263 646.312 162.821 860.723l348.442-696.836L859.67 860.723z\" p-id=\"6374\" fill=\"#f4ea2a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol